import React from 'react';
import { ShieldCheck, Cloud, Server, Star, Users, Trophy } from 'lucide-react';
import { certifications, achievements } from '../data/mock';

const iconMap = {
  'shield-check': ShieldCheck,
  'cloud': Cloud,
  'server': Server,
  'star': Star,
  'users': Users,
  'trophy': Trophy
};

const Achievements = () => {
  return (
    <section
      id="achievements"
      className="py-16 md:py-20 px-6 border-b border-stone-400/25 dark:border-stone-500/20"
    >
      <div className="max-w-6xl mx-auto">
        <div className="mb-10">
          <h2 className="text-3xl font-bold text-stone-900 dark:text-stone-100 mb-3 leading-tight">
            Certifications & Achievements
          </h2>
          <div className="w-16 h-1 bg-amber-800 dark:bg-amber-600 rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-lg font-bold text-stone-900 dark:text-stone-100 mb-4">
              Professional Certifications
            </h3>
            <div className="space-y-3">
              {certifications.map((cert) => {
                const Icon = iconMap[cert.icon];
                return (
                  <div
                    key={cert.id}
                    className="p-4 rounded-xl bg-white/60 dark:bg-stone-800/60 backdrop-blur-md border border-stone-200/50 dark:border-stone-700/50 hover:shadow-lg transition-all"
                  >
                    <div className="flex items-start space-x-3">
                      <div className="p-2 rounded-lg bg-amber-100 dark:bg-amber-900/30">
                        <Icon className="w-4 h-4 text-amber-800 dark:text-amber-600" />
                      </div>
                      <div className="flex-1">
                        <h4 className="text-sm font-semibold text-stone-900 dark:text-stone-100 mb-0.5">
                          {cert.title}
                        </h4>
                        <p className="text-xs text-stone-600 dark:text-stone-300">{cert.issuer}</p>
                        <p className="text-xs text-stone-500 dark:text-stone-400 mt-0.5">
                          {cert.date}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold text-stone-900 dark:text-stone-100 mb-4">
              Key Achievements
            </h3>
            <div className="space-y-3">
              {achievements.map((achievement) => {
                const Icon = iconMap[achievement.icon];
                return (
                  <div
                    key={achievement.id}
                    className="p-4 rounded-xl bg-white/60 dark:bg-stone-800/60 backdrop-blur-md border border-stone-200/50 dark:border-stone-700/50 hover:shadow-lg transition-all"
                  >
                    <div className="flex items-start space-x-3">
                      <div className="p-2 rounded-lg bg-amber-100 dark:bg-amber-900/30">
                        <Icon className="w-4 h-4 text-amber-800 dark:text-amber-600" />
                      </div>
                      <div className="flex-1">
                        <h4 className="text-sm font-semibold text-stone-900 dark:text-stone-100 mb-0.5">
                          {achievement.title}
                        </h4>
                        <p className="text-xs text-stone-600 dark:text-stone-300">
                          {achievement.description}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Achievements;
